<template>
  <div>
    <div class="chip" v-for="chip in chips">
      <span>{{ chip }}</span>
      <button
        type="button"
        title="Remove chip"
        arial-label="Remove chip"
        @click="onRemoveChip(chip)"
      >
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chips: Array,
    onRemoveChip: Function,
  },
};
</script>

<style lang="scss">
.chip {
  transition: all 0.3s ease-in-out;
  background-color: #fff;
  border-radius: 30px;
  border: 1px solid #d3d2d2;
  display: inline-flex;
  align-items: center;
  padding: 4px 6px 4px 6px;
  margin-right: 6px;
  margin-bottom: 6px;

  > * {
    margin-right: 2px;
    margin-left: 2px;
    color: #757373;
  }

  &:hover,
  &:focus {
    background-color: #e3e2e2;
  }

  button {
    cursor: pointer;
    border: none;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    background: none;
    display: inline-flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/chip.vue